<template>
    <div>
        <div class="titolo-sezioni-cart">Specifica gli extra</div>
        <div class="bg-gray p-3">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4" v-for="(extra, i) in this.extras">
                    <input type="text" class="form-control d-inline-block mb-2" style="width: 110px;" v-if="extra.tipo === 'LIBERO'"
                           @input="(e) => changeFree(e, extra)">
                    <div v-if="extra.tipo === 'SCELTA'" class="d-inline-flex flex-row mb-2" style="width: 110px;">
                        <!-- A.A. Decisione del 22/11/2021 extra default a SI -->
                        <mcw-radio v-if="extra.tipo === 'SCELTA'" @change="changeChoice(extra, 1)" :name="`extra_${i}`"
                                   :label="$t('si')" :value="extra.id.toString()" checked class="mr-2"/>
                        <mcw-radio v-if="extra.tipo === 'SCELTA'" @change="changeChoice(extra, 0)" :name="`extra_${i}`"
                                   :label="$t('no')" :value="extra.id.toString()"/>
                    </div>
                    <label class="d-inline-block text-uppercase ml-2">{{ extra.traduzione.nome }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Extras",
    props: ['extras'],
    data() {
        return {
            form: this.extras.map((extra) => {
                return {id: extra.id, value: extra.tipo === 'LIBERO' ? null : 1}
            })
        };
    },
    computed: {
        free_extras: function () {
            return this.extras.filter((extra) => extra.tipo === "LIBERO");
        },
        choice_extras: function () {
            return this.extras.filter((extra) => extra.tipo === "SCELTA");
        }
    },
    methods: {
        changeChoice: function (extra, value) {
            const index = this.form.findIndex(item => item.id === extra.id);
            if (index >= 0) this.form[index].value = value;

            this.$emit('onExtrasChange', this.form);
        },
        changeFree: function (e, extra) {
            const index = this.form.findIndex(item => item.id === extra.id);
            if (index >= 0) this.form[index].value = e.target.value !== '' ? e.target.value : null;

            this.$emit('onExtrasChange', this.form);
        }
    }
}
</script>